module.exports = __webpack_public_path__ + "static/Gilroy-Black-32f3e96b9a0295aebb09f529928bf15c.woff2";